/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_List_Filter_AllInputs */

const en_admin_company_list_filter_all = /** @type {(inputs: Admin_Company_List_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const de_admin_company_list_filter_all = /** @type {(inputs: Admin_Company_List_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Admin_Company_List_Filter_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_company_list_filter_all = /** @type {((inputs?: Admin_Company_List_Filter_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_List_Filter_AllInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_company_list_filter_all(inputs)
	return en_admin_company_list_filter_all(inputs)
});